import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PressDownloadState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PressDownloadQuery extends QueryEntity<PressDownloadState> {

  constructor(protected store: Store) {
    super(store);
  }

}
